__turbopack_context__.v({
  "betmidasLink": "license-module-sass-module__kLCiyq__betmidasLink",
  "licenseLogoBetmidas": "license-module-sass-module__kLCiyq__licenseLogoBetmidas",
});
